// extracted by mini-css-extract-plugin
export default {"container":"Bar_container__OWvzp"};